export const analyzeContractText = async (contractText,agreementType) => {
  const res = await fetch('https://romang.readyforyourreview.com/api.php/analyze-text', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      agreement_type: agreementType,
      text: contractText,
    }),
  });

  const json = await res.json();
  if (json.status === 1) {
    return json;
  } else {
    throw new Error(json.msg || 'Failed to analyze text');
  }
};